import * as React from 'react'

export const AppProcessFlow = () => {
  return <div>In App tab: Process Flows</div>
}
